<template>
    <header class="page-header sticky-top px-xl-4 px-sm-2 px-0 py-lg-2 py-1" id="page-header" v-if="$route.meta.domain != 'documentation'">
        <div class="container-fluid p-0">
            <nav class="navbar">
                <!-- start: toggle btn -->
                    <div class="d-flex">
                        <button type="button" @click="toggleSidebar" class="btn btn-link d-none d-xl-block sidebar-mini-btn p-0 text-primary">
                            <span class="hamburger-icon" v-bind:class="{active:sidebarmini}">
                                <span class="line"></span>
                                <span class="line"></span>
                                <span class="line"></span>
                            </span>
                            </button>
                        <button type="button" @click="collapseSidebar" class="btn btn-link d-block d-xl-none menu-toggle p-0 text-primary">
                            <span class="hamburger-icon" v-bind:class="{active:sidebarCollapse}">
                                <span class="line"></span>
                                <span class="line"></span>
                                <span class="line"></span>
                            </span>
                        </button>
                    </div>
                    <!-- start: search area -->
                <div class="header-left flex-grow-1 d-none d-md-block">
                <div class="main-search px-3 flex-fill">
                    <form @submit.prevent="goToFirstResult">
                        <input
                            v-model="searchQuery"
                            class="form-control border-0"
                            type="text"
                            placeholder="Cari menu..."
                            autocomplete="off"
                            @focus="issearch = true"
                            @blur="handleSearchBlur"
                        >
                    </form>
                    <div class="card shadow rounded-4 search-result slidedown" :class="{ show : issearch}" >
                        <div class="card-body">
                            <small v-if="!searchQuery.trim()" class="text-muted">Ketik nama menu yang ingin dicari...</small>
                            <small v-else-if="searchResults.length === 0" class="text-muted">Menu "{{ searchQuery }}" tidak ditemukan</small>
                            <div v-else class="card list-group list-group-flush list-group-custom border">
                                <router-link
                                    v-for="item in searchResults"
                                    :key="item.path"
                                    class="list-group-item list-group-item-action text-truncate"
                                    :to="item.path"
                                    @click="selectResult()"
                                >
                                    <div class="fw-bold">{{ item.nama }}</div>
                                </router-link>
                            </div>
                        </div>
                    </div>
                    <div class="overlay"></div>
                </div>
                </div>
                <!-- start: link -->
                <ul class="header-right justify-content-end d-flex align-items-center mb-0">
                    <!-- start: quick light dark -->
                    <li class="d-none d-xl-inline-block">
                    <a class="nav-link fullscreen" href="javascript:void(0);" @click="toggleFullScreen()">
                        <svg viewBox="0 0 16 16" width="18px" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M5.8279 10.172C5.73414 10.0783 5.60698 10.0256 5.4744 10.0256C5.34182 10.0256 5.21467 10.0783 5.1209 10.172L1.0249 14.268V11.5C1.0249 11.3674 0.972224 11.2402 0.878456 11.1464C0.784688 11.0527 0.657511 11 0.524902 11C0.392294 11 0.265117 11.0527 0.171349 11.1464C0.0775808 11.2402 0.0249023 11.3674 0.0249023 11.5V15.475C0.0249023 15.6076 0.0775808 15.7348 0.171349 15.8285C0.265117 15.9223 0.392294 15.975 0.524902 15.975H4.4999C4.63251 15.975 4.75969 15.9223 4.85346 15.8285C4.94722 15.7348 4.9999 15.6076 4.9999 15.475C4.9999 15.3424 4.94722 15.2152 4.85346 15.1214C4.75969 15.0277 4.63251 14.975 4.4999 14.975H1.7319L5.8279 10.879C5.92164 10.7852 5.9743 10.6581 5.9743 10.5255C5.9743 10.3929 5.92164 10.2658 5.8279 10.172ZM10.1719 10.172C10.2657 10.0783 10.3928 10.0256 10.5254 10.0256C10.658 10.0256 10.7851 10.0783 10.8789 10.172L14.9749 14.268V11.5C14.9749 11.3674 15.0276 11.2402 15.1213 11.1464C15.2151 11.0527 15.3423 11 15.4749 11C15.6075 11 15.7347 11.0527 15.8285 11.1464C15.9222 11.2402 15.9749 11.3674 15.9749 11.5V15.475C15.9749 15.6076 15.9222 15.7348 15.8285 15.8285C15.7347 15.9223 15.6075 15.975 15.4749 15.975H11.4999C11.3673 15.975 11.2401 15.9223 11.1463 15.8285C11.0526 15.7348 10.9999 15.6076 10.9999 15.475C10.9999 15.3424 11.0526 15.2152 11.1463 15.1214C11.2401 15.0277 11.3673 14.975 11.4999 14.975H14.2679L10.1719 10.879C10.0782 10.7852 10.0255 10.6581 10.0255 10.5255C10.0255 10.3929 10.0782 10.2658 10.1719 10.172ZM5.8279 5.82799C5.73414 5.92173 5.60698 5.97439 5.4744 5.97439C5.34182 5.97439 5.21467 5.92173 5.1209 5.82799L1.0249 1.73199V4.49999C1.0249 4.6326 0.972224 4.75978 0.878456 4.85355C0.784688 4.94732 0.657511 4.99999 0.524902 4.99999C0.392294 4.99999 0.265117 4.94732 0.171349 4.85355C0.0775808 4.75978 0.0249023 4.6326 0.0249023 4.49999V0.524994C0.0249023 0.392386 0.0775808 0.265209 0.171349 0.17144C0.265117 0.0776723 0.392294 0.0249939 0.524902 0.0249939H4.4999C4.63251 0.0249939 4.75969 0.0776723 4.85346 0.17144C4.94722 0.265209 4.9999 0.392386 4.9999 0.524994C4.9999 0.657602 4.94722 0.784779 4.85346 0.878547C4.75969 0.972315 4.63251 1.02499 4.4999 1.02499H1.7319L5.8279 5.12099C5.92164 5.21476 5.9743 5.34191 5.9743 5.47449C5.9743 5.60708 5.92164 5.73423 5.8279 5.82799Z" />
                        <path class="fill-secondary" d="M10.5253 5.97439C10.3927 5.97439 10.2655 5.92173 10.1718 5.82799C10.078 5.73423 10.0254 5.60708 10.0254 5.47449C10.0254 5.34191 10.078 5.21476 10.1718 5.12099L14.2678 1.02499H11.4998C11.3672 1.02499 11.24 0.972315 11.1462 0.878547C11.0525 0.784779 10.9998 0.657602 10.9998 0.524994C10.9998 0.392386 11.0525 0.265209 11.1462 0.17144C11.24 0.0776723 11.3672 0.0249939 11.4998 0.0249939H15.4748C15.6074 0.0249939 15.7346 0.0776723 15.8283 0.17144C15.9221 0.265209 15.9748 0.392386 15.9748 0.524994V4.49999C15.9748 4.6326 15.9221 4.75978 15.8283 4.85355C15.7346 4.94732 15.6074 4.99999 15.4748 4.99999C15.3422 4.99999 15.215 4.94732 15.1212 4.85355C15.0275 4.75978 14.9748 4.6326 14.9748 4.49999V1.73199L10.8788 5.82799C10.785 5.92173 10.6579 5.97439 10.5253 5.97439Z" />
                        </svg>
                    </a>
                    </li>
                    <!-- start: Language dropdown-menu -->
                    <li class="d-none d-xl-inline-block">
                    <div class="dropdown morphing scale-left Language">
                        <a class="nav-link dropdown-toggle after-none" href="#" role="button" data-bs-toggle="dropdown">
                        <svg viewBox="0 0 16 16" width="18px" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                            <path class="fill-secondary" d="M4.545 6.714 4.11 8H3l1.862-5h1.284L8 8H6.833l-.435-1.286H4.545zm1.634-.736L5.5 3.956h-.049l-.679 2.022H6.18z" />
                            <path d="M0 2a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v3h3a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-3H2a2 2 0 0 1-2-2V2zm2-1a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H2zm7.138 9.995c.193.301.402.583.63.846-.748.575-1.673 1.001-2.768 1.292.178.217.451.635.555.867 1.125-.359 2.08-.844 2.886-1.494.777.665 1.739 1.165 2.93 1.472.133-.254.414-.673.629-.89-1.125-.253-2.057-.694-2.82-1.284.681-.747 1.222-1.651 1.621-2.757H14V8h-3v1.047h.765c-.318.844-.74 1.546-1.272 2.13a6.066 6.066 0 0 1-.415-.492 1.988 1.988 0 0 1-.94.31z" />
                        </svg>
                        </a>
                        <div class="dropdown-menu rounded-4 shadow border-0 p-0" data-bs-popper="none">
                        <div class="card">
                            <div class="list-group list-group-custom" style="width: 200px;">
                            <a href="#" class="list-group-item"><span class="flag-icon flag-icon-gb me-2"></span>UK English</a>
                            <a href="#" class="list-group-item"><span class="flag-icon flag-icon-us me-2"></span>US English</a>
                            <a href="#" class="list-group-item"><span class="flag-icon flag-icon-de me-2"></span>Germany</a>
                            <a href="#" class="list-group-item"><span class="flag-icon flag-icon-in me-2"></span>Hindi</a>
                            <a href="#" class="list-group-item"><span class="flag-icon flag-icon-sa me-2"></span>Saudi Arabia</a>
                            </div>
                        </div>
                        </div>
                    </div>
                    </li>
                    <!-- start: My notes toggle modal -->
                    <li class="d-none d-sm-inline-block d-xl-none">
                    <a class="nav-link" href="#" data-bs-toggle="modal" data-bs-target="#MynotesModal">
                        <svg viewBox="0 0 16 16" width="18px" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path class="fill-secondary" d="M1.5 0A1.5 1.5 0 0 0 0 1.5V13a1 1 0 0 0 1 1V1.5a.5.5 0 0 1 .5-.5H14a1 1 0 0 0-1-1H1.5z" />
                        <path d="M3.5 2A1.5 1.5 0 0 0 2 3.5v11A1.5 1.5 0 0 0 3.5 16h6.086a1.5 1.5 0 0 0 1.06-.44l4.915-4.914A1.5 1.5 0 0 0 16 9.586V3.5A1.5 1.5 0 0 0 14.5 2h-11zM3 3.5a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 .5.5V9h-4.5A1.5 1.5 0 0 0 9 10.5V15H3.5a.5.5 0 0 1-.5-.5v-11zm7 11.293V10.5a.5.5 0 0 1 .5-.5h4.293L10 14.793z" />
                        </svg>
                    </a>
                    </li>
                    <!-- start: Recent Chat toggle modal -->
                    <li class="d-none d-sm-inline-block d-xl-none">
                    <a class="nav-link" href="#" data-bs-toggle="modal" data-bs-target="#RecentChat">
                        <svg viewBox="0 0 16 16" width="18px" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14 1a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H4.414A2 2 0 0 0 3 11.586l-2 2V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12.793a.5.5 0 0 0 .854.353l2.853-2.853A1 1 0 0 1 4.414 12H14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z" />
                        <path class="fill-secondary" d="M3 3.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zM3 6a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9A.5.5 0 0 1 3 6zm0 2.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5z" />
                        </svg>
                    </a>
                    </li>
                    <!-- start: quick light dark -->
                    <li>
                    <a class="nav-link quick-light-dark" href="#"  @click="themeMode('mode')">
                        <svg viewBox="0 0 16 16" width="18px" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6 .278a.768.768 0 0 1 .08.858 7.208 7.208 0 0 0-.878 3.46c0 4.021 3.278 7.277 7.318 7.277.527 0 1.04-.055 1.533-.16a.787.787 0 0 1 .81.316.733.733 0 0 1-.031.893A8.349 8.349 0 0 1 8.344 16C3.734 16 0 12.286 0 7.71 0 4.266 2.114 1.312 5.124.06A.752.752 0 0 1 6 .278zM4.858 1.311A7.269 7.269 0 0 0 1.025 7.71c0 4.02 3.279 7.276 7.319 7.276a7.316 7.316 0 0 0 5.205-2.162c-.337.042-.68.063-1.029.063-4.61 0-8.343-3.714-8.343-8.29 0-1.167.242-2.278.681-3.286z" />
                        <path class="fill-secondary" d="M10.794 3.148a.217.217 0 0 1 .412 0l.387 1.162c.173.518.579.924 1.097 1.097l1.162.387a.217.217 0 0 1 0 .412l-1.162.387a1.734 1.734 0 0 0-1.097 1.097l-.387 1.162a.217.217 0 0 1-.412 0l-.387-1.162A1.734 1.734 0 0 0 9.31 6.593l-1.162-.387a.217.217 0 0 1 0-.412l1.162-.387a1.734 1.734 0 0 0 1.097-1.097l.387-1.162zM13.863.099a.145.145 0 0 1 .274 0l.258.774c.115.346.386.617.732.732l.774.258a.145.145 0 0 1 0 .274l-.774.258a1.156 1.156 0 0 0-.732.732l-.258.774a.145.145 0 0 1-.274 0l-.258-.774a1.156 1.156 0 0 0-.732-.732l-.774-.258a.145.145 0 0 1 0-.274l.774-.258c.346-.115.617-.386.732-.732L13.863.1z" />
                        </svg>
                    </a>
                    </li>
                    <!-- start: User dropdown-menu -->
                    <li>
                    <div class="dropdown morphing scale-left user-profile mx-lg-3 mx-2">
                        <a class="nav-link dropdown-toggle rounded-circle after-none p-0" href="#" role="button" data-bs-toggle="dropdown">
                        <img class="avatar img-thumbnail rounded-circle shadow" src="../../assets/img/profile_av.png" alt="">
                        </a>
                        <div class="dropdown-menu border-0 rounded-4 shadow p-0">
                        <div class="card border-0 w240">
                            <div class="card-body border-bottom d-flex">
                            <img class="avatar rounded-circle" src="../../assets/img/profile_av.png" alt="">
                            <div class="flex-fill ms-3">
                                <h6 class="card-title mb-0">{{ currentUser?.nama_lengkap || 'User' }}</h6>
                                <span class="text-muted">{{ roleLabel }}</span>
                            </div>
                            </div>
                            <div class="list-group m-2 mb-3">
                            <router-link v-if="currentUser?.role === 'superadmin'" class="list-group-item list-group-item-action border-0" to="/user-management/list"><i class="w30 fa fa-users"></i>User Management</router-link>
                            <router-link v-if="currentUser?.role === 'superadmin'" class="list-group-item list-group-item-action border-0" to="/role-management/list"><i class="w30 fa fa-shield"></i>Role Management</router-link>
                            <a v-if="currentUser?.roles?.includes('nasabah')" href="javascript:void(0);" class="list-group-item list-group-item-action border-0" data-bs-toggle="modal" data-bs-target="#profilSayaModal" @click="openProfilSayaFromMenu"><i class="w30 fa fa-user"></i>Profil Saya</a>
                            <a href="javascript:void(0);" class="list-group-item list-group-item-action border-0" data-bs-toggle="modal" data-bs-target="#changePasswordModal"><i class="w30 fa fa-key"></i>Change Password</a>
                            </div>
                            <a href="javascript:void(0);" @click="doLogout" class="btn bg-secondary text-light text-uppercase rounded-0">Sign out</a>
                        </div>
                        </div>
                    </div>
                    </li>
                </ul>
            </nav>
        </div>
    </header>
    <header class="page-header sticky-top px-xl-4 px-sm-2 px-0 py-lg-2 py-1" id="page-header" v-else>
      <div class="container">
        <nav class="navbar">
          <!-- start: toggle btn -->
          <div class="d-flex">
            <button type="button" class="btn btn-link d-block d-xl-none menu-toggle ps-0 text-primary" @click="toggleSidebar">
              <span><i class="fa fa-navicon"></i></span>
            </button>
            <router-link to="/dashboard/analysis" class="brand-icon d-flex align-items-center me-1 me-sm-3 me-lg-4 text-primary">
              <span class="fs-4 fw-bold">Doc<span class="d-lg-inline-block d-none">umentation</span></span>
            </router-link>
          </div>
          <!-- start: search area -->
          <div class="header-left flex-grow-1 d-none d-md-block">
            <div class="main-search px-3 flex-fill">
                <form>
                    <input class="form-control border-0" type="text" placeholder="Enter your search key word" @click="issearch=!issearch" @blur="issearch = false" autocomplete="off">
                </form>
                <div class="card shadow rounded-4 search-result slidedown" :class="{ show : issearch}" >
                    <div class="card-body">
                        <small class="text-uppercase text-muted">Recent searches</small>
                        <div class="d-flex flex-wrap align-items-start mt-2 mb-4">
                        <router-link class="m-1 p-2 lift badge text-bg-danger" to="#">HRMS Admin</router-link>
                        <router-link class="m-1 p-2 lift badge text-bg-warning" to="#">Hospital Admin</router-link>
                        <router-link class="m-1 p-2 lift badge text-bg-success" to="#">Project</router-link>
                        <router-link class="m-1 p-2 lift badge text-bg-info" to="#">Social App</router-link>
                        <router-link class="m-1 p-2 lift badge text-bg-primary" to="#">University Admin</router-link>
                        </div>
                        <small class="text-uppercase text-muted">Suggestions</small>
                        <div class="card list-group list-group-flush list-group-custom mt-2 border">
                        <router-link class="list-group-item list-group-item-action text-truncate" to="#">
                            <div class="fw-bold">Helper Class</div>
                            <small class="text-muted">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</small>
                        </router-link>
                        <router-link class="list-group-item list-group-item-action text-truncate" to="#">
                            <div class="fw-bold">Date Range Picker</div>
                            <small class="text-muted">There are many variations of passages of Lorem Ipsum available</small>
                        </router-link>
                        <router-link class="list-group-item list-group-item-action text-truncate" to="#">
                            <div class="fw-bold">Image Input</div>
                            <small class="text-muted">It is a long established fact that a reader will be distracted</small>
                        </router-link>
                        <router-link class="list-group-item list-group-item-action text-truncate" to="#">
                            <div class="fw-bold">DataTables for jQuery</div>
                            <small class="text-muted">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</small>
                        </router-link>
                        <router-link class="list-group-item list-group-item-action text-truncate" to="#">
                            <div class="fw-bold">Development Setup</div>
                            <small class="text-muted">Contrary to popular belief, Lorem Ipsum is not simply random text.</small>
                        </router-link>
                        </div>
                    </div>
                </div>
            </div>
          </div>
          <!-- start: link -->
          <div class="h-right justify-content-end d-flex align-items-center">
            <a class="btn btn-light" href="javascript:void(0);"><i class="fa fa-external-link me-2"></i>Preview</a>
            <a class="btn btn-danger mx-2" href="javascript:void(0);"><i class="fa fa-download me-2"></i>Download</a>
          </div>
        </nav>
      </div>
    </header>

    <!-- Modal: profil saya (nasabah) -->
    <div class="modal fade" id="profilSayaModal" tabindex="-1" aria-hidden="true" ref="profilSayaModal">
      <div class="modal-dialog">
        <div class="modal-content">
          <form @submit.prevent="submitProfilSaya">
            <div class="modal-header">
              <h5 class="modal-title">Profil Saya</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div v-if="profilSayaHint" class="alert alert-warning py-2">Silakan lengkapi Data Bank dan Rekening Pencairan terlebih dahulu untuk bisa mengajukan penarikan.</div>
              <div v-if="profilError" class="alert alert-danger py-2">{{ profilError }}</div>
              <div v-if="profilSuccess" class="alert alert-success py-2">Data profil berhasil disimpan</div>
              <div class="row g-3">
                <div class="col-md-6">
                  <label class="form-label">Nama</label>
                  <input v-model="profilForm.nama_nasabah" type="text" class="form-control" minlength="3" maxlength="100">
                </div>
                <div class="col-md-6">
                  <label class="form-label">No. HP</label>
                  <input v-model="profilForm.no_hp" type="tel" class="form-control">
                </div>
                <div class="col-md-6">
                  <label class="form-label">Email</label>
                  <input v-model="profilForm.email" type="email" class="form-control">
                </div>
                <div class="col-12">
                  <label class="form-label">Alamat</label>
                  <textarea v-model="profilForm.alamat" class="form-control" rows="2" placeholder="Termasuk RT/RW" minlength="5" maxlength="255"></textarea>
                </div>
                <div class="col-md-6">
                  <label class="form-label">Bank Pencairan</label>
                  <input v-model="profilForm.bank_pencairan" type="text" class="form-control" placeholder="misal: BCA">
                </div>
                <div class="col-md-6">
                  <label class="form-label">Rekening Pencairan</label>
                  <input v-model="profilForm.rekening_pencairan" type="text" class="form-control" placeholder="No. rekening">
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">Batal</button>
              <button type="submit" class="btn btn-primary" :disabled="savingProfil">{{ savingProfil ? 'Menyimpan...' : 'Simpan' }}</button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <!-- Modal: change password -->
    <div class="modal fade" id="changePasswordModal" tabindex="-1" aria-hidden="true" ref="changePasswordModal">
      <div class="modal-dialog">
        <div class="modal-content">
          <form @submit.prevent="submitChangePassword">
            <div class="modal-header">
              <h5 class="modal-title">Ganti Password</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div v-if="currentUser?.must_change_password" class="alert alert-warning py-2">Untuk keamanan, silakan ganti password default Anda.</div>
              <div v-if="passwordError" class="alert alert-danger py-2">{{ passwordError }}</div>
              <div v-if="passwordSuccess" class="alert alert-success py-2">Password berhasil diubah</div>
              <div class="mb-3">
                <label class="form-label">Password Lama</label>
                <input v-model="passwordForm.password_lama" type="password" class="form-control" required>
              </div>
              <div class="mb-3">
                <label class="form-label">Password Baru</label>
                <input v-model="passwordForm.password_baru" type="password" class="form-control" minlength="6" required>
              </div>
              <div class="mb-3">
                <label class="form-label">Konfirmasi Password Baru</label>
                <input v-model="passwordConfirm" type="password" class="form-control" minlength="6" required>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">Batal</button>
              <button type="submit" class="btn btn-primary" :disabled="savingPassword">{{ savingPassword ? 'Menyimpan...' : 'Simpan' }}</button>
            </div>
          </form>
        </div>
      </div>
    </div>
</template>
<script>
import { Modal } from 'bootstrap';
import { getCurrentUser, updateCurrentUser, logout } from "@/api/auth";
import { clearMenuCache, getCachedMenus, isMenuVisible } from "@/api/menus";
import { changeMyPassword, getMyNasabah, updateMyNasabah } from "@/api/me";

const STATIC_SEARCH_ITEMS = [
    { nama: 'Dashboard', path: '/dashboard/bank-sampah', role: null },
    { nama: 'User Management', path: '/user-management/list', role: 'superadmin' },
    { nama: 'Menu Management', path: '/menu-management/list', role: 'superadmin' },
    { nama: 'Role Management', path: '/role-management/list', role: 'superadmin' },
    { nama: 'Audit Trail', path: '/audit-trail/list', role: 'superadmin' },
];

  export default {
    name: 'HeaderComponent',
    data(){
        return {
            issearch:false,
            sidebarmini:false,
            sidebarCollapse:false,
            currentUser: getCurrentUser(),
            searchQuery: '',
            passwordForm: { password_lama: '', password_baru: '' },
            passwordConfirm: '',
            passwordError: '',
            passwordSuccess: false,
            savingPassword: false,
            profilForm: { nama_nasabah: '', no_hp: '', email: '', alamat: '', bank_pencairan: '', rekening_pencairan: '' },
            profilError: '',
            profilSuccess: false,
            profilSayaHint: false,
            savingProfil: false,
        }
    },
    mounted(){
        this.emitter.on('request-open-profil-saya', this.showProfilSayaModal);
        if (this.currentUser?.must_change_password) {
            this.$nextTick(() => {
                if (this.$refs.changePasswordModal) {
                    Modal.getOrCreateInstance(this.$refs.changePasswordModal).show();
                }
            });
        }
    },
    beforeUnmount(){
        this.emitter.off('request-open-profil-saya', this.showProfilSayaModal);
    },
    computed: {
        roleLabel() {
            const labels = { superadmin: 'Superadmin', admin: 'Admin', petugas: 'Petugas', nasabah: 'Nasabah' };
            const roles = this.currentUser?.roles || [];
            const joined = roles.map((r) => labels[r] || r).join(', ');
            return joined || 'User';
        },
        searchResults() {
            const q = this.searchQuery.trim().toLowerCase();
            if (!q) return [];
            const roles = this.currentUser?.roles || [];
            const staticItems = STATIC_SEARCH_ITEMS.filter((item) => !item.role || roles.includes('superadmin'));
            const businessItems = getCachedMenus()
                .filter((m) => m.is_active && isMenuVisible(m.kode, roles))
                .map((m) => ({ nama: m.nama, path: m.path }));
            return [...staticItems, ...businessItems]
                .filter((item) => item.nama.toLowerCase().includes(q))
                .slice(0, 8);
        },
    },
    methods:{
        handleSearchBlur(){
            setTimeout(() => { this.issearch = false; }, 150);
        },
        selectResult(){
            this.searchQuery = '';
            this.issearch = false;
        },
        goToFirstResult(){
            const first = this.searchResults[0];
            if (first) {
                this.$router.push(first.path);
                this.selectResult();
            }
        },
        doLogout(){
            logout();
            clearMenuCache();
            this.$router.push('/authentication/sign-in');
        },
        async submitChangePassword(){
            this.passwordError = '';
            this.passwordSuccess = false;
            if (this.passwordForm.password_baru !== this.passwordConfirm) {
                this.passwordError = 'Konfirmasi password baru tidak cocok';
                return;
            }
            this.savingPassword = true;
            try {
                await changeMyPassword(this.passwordForm);
                this.passwordSuccess = true;
                this.passwordForm = { password_lama: '', password_baru: '' };
                this.passwordConfirm = '';
                this.currentUser = updateCurrentUser({ must_change_password: false });
            } catch (err) {
                this.passwordError = err.response?.data?.message || 'Gagal mengubah password';
            } finally {
                this.savingPassword = false;
            }
        },
        async openProfilSaya(){
            this.profilError = '';
            this.profilSuccess = false;
            try {
                const nasabah = await getMyNasabah();
                this.profilForm = {
                    nama_nasabah: nasabah.nama_nasabah || '',
                    no_hp: nasabah.no_hp || '',
                    email: nasabah.email || '',
                    alamat: nasabah.alamat || '',
                    bank_pencairan: nasabah.bank_pencairan || '',
                    rekening_pencairan: nasabah.rekening_pencairan || '',
                };
            } catch (err) {
                this.profilError = err.response?.data?.message || 'Gagal memuat data profil';
            }
        },
        openProfilSayaFromMenu(){
            this.profilSayaHint = false;
            this.openProfilSaya();
        },
        async showProfilSayaModal(){
            this.profilSayaHint = true;
            await this.openProfilSaya();
            if (!this.$refs.profilSayaModal) return;
            Modal.getOrCreateInstance(this.$refs.profilSayaModal).show();
        },
        async submitProfilSaya(){
            this.profilError = '';
            this.profilSuccess = false;
            this.savingProfil = true;
            try {
                await updateMyNasabah(this.profilForm);
                this.profilSuccess = true;
                this.profilSayaHint = false;
                this.emitter.emit('profil-updated');
            } catch (err) {
                this.profilError = err.response?.data?.message || 'Gagal menyimpan data profil';
            } finally {
                this.savingProfil = false;
            }
        },
        toggleSidebar(){
            this.sidebarmini = document.getElementById('sidebar').classList.toggle('sidebar-mini');
        },
        collapseSidebar(){
            this.sidebarCollapse = document.getElementById('sidebar').classList.toggle('open');
        },
        themeMode(type){
            let theme = document.documentElement.getAttribute("data-theme");
            if(type == 'mode'){
                if(theme != 'light'){
                    document.documentElement.setAttribute("data-theme", 'light');
                    this.emitter.emit('lightmode')
                } else {
                    this.emitter.emit('darkmode')
                    document.documentElement.setAttribute("data-theme", 'dark');
                }
            }
        },
        toggleFullScreen(){
            var element = document.documentElement;
            if(document.fullscreenElement == null){
                element.requestFullscreen();
            } else {
                document.exitFullscreen();
            }
        }
    }
  }
</script>
<style scoped>
@import '../../assets/fonts/flag-icon/css/flag-icon.min.css';
</style>